<div>
  <div id="klarna-payments-container">
    <!-- A Klarna Element will be inserted here. -->
  </div>
</div>
